import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectQrModalStatus = createSelector(
  [(store: RootState) => store.supervisorDocumentsList.qrModalStatus],
  (modalStatus) => modalStatus
);
